package com.tovtalk.ui.screen.onboarding

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tovtalk.ui.theme.TovTalkBrand
import com.tovtalk.utils.strings.StringProvider

@Composable
fun WelcomeScreen(onContinue: () -> Unit) {
    OnboardingLayout(
        progressCurrent = 0,
        progressTotal = 0,
        onSkip = null,
        ctaText = StringProvider.get("onboarding_welcome_cta"),
        onCta = onContinue,
        headerContent = {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 32.dp)
                    .padding(top = 48.dp, bottom = 48.dp),
            ) {
                Text(
                    text = "TOVTALK",
                    color = TovTalkBrand,
                    fontSize = 12.sp,
                    fontWeight = FontWeight.Bold,
                    letterSpacing = 3.sp,
                )
                Spacer(Modifier.height(16.dp))
                Text(
                    text = StringProvider.get("onboarding_welcome_title"),
                    color = Color.White,
                    fontSize = 44.sp,
                    fontWeight = FontWeight.Black,
                    lineHeight = 46.sp,
                )
                Spacer(Modifier.height(18.dp))
                Box(
                    modifier = Modifier
                        .size(width = 40.dp, height = 2.dp)
                        .background(TovTalkBrand),
                )
                Spacer(Modifier.height(16.dp))
                Text(
                    text = StringProvider.get("onboarding_welcome_tagline"),
                    color = Color.White.copy(alpha = 0.55f),
                    fontSize = 14.sp,
                    lineHeight = 20.sp,
                )
            }
        },
        content = {
            // No scrollable content on welcome screen
        },
    )
}
